import type { ComponentType } from "react";
import type { RowComponentProps } from "react-window";
import { LISTBOX_PADDING } from "../../../../PitSelector.constants";
import type {
  OptionItemData,
  PitSelectorDefaultRenderOptionProps,
  PitSelectorDefaultRenderOptionSlotProps,
  PitSelectorOptionOnClickType,
  PitSelectorSlots,
} from "../../../../PitSelector.types";

type ItemData = OptionItemData[];

interface RowProps {
  itemData: ItemData;
  RenderOption: ComponentType<PitSelectorDefaultRenderOptionProps>;
  onClick?: PitSelectorOptionOnClickType;
  slots?: PitSelectorSlots;
  slotProps?: PitSelectorDefaultRenderOptionSlotProps;
}

export default function PitSelectorRowComponent({
  index,
  itemData,
  RenderOption,
  onClick,
  slots,
  slotProps,
  style,
}: RowComponentProps<RowProps>) {
  const [{ key, ...optionProps }, option] = itemData[index];

  const inlineStyle = {
    ...style,
    top: ((style.top as number) ?? 0) + LISTBOX_PADDING,
    ...optionProps.style,
  };

  return (
    <RenderOption
      key={key}
      option={option}
      {...optionProps}
      style={inlineStyle}
      onClick={onClick || optionProps.onClick}
      slots={slots}
      slotProps={slotProps}
    />
  );
}
